import { ɵɵdefineInjectable, Injectable, ɵɵinject, EventEmitter, Component, forwardRef, Attribute, Input, ViewChild, Output, Injector, Optional, Inject, NgModule } from '@angular/core';
import { HttpRequest, HttpClient } from '@angular/common/http';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, FormsModule } from '@angular/forms';
import { UploadStatus, NgxUploaderModule } from 'ngx-uploader';
import { NgbActiveModal, NgbModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { fromEvent } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RichEditorComponent, provideValueAccessor, InputService, ContextFormService, FwFormsModule } from 'fw-core';
import { DomSanitizer } from '@angular/platform-browser';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ngx-uploader';
import * as ɵngcc4 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc5 from 'ngx-spinner';
import * as ɵngcc6 from 'angular-cropperjs';
import * as ɵngcc7 from 'fw-core';
import * as ɵngcc8 from '@angular/platform-browser';
import * as ɵngcc9 from '@angular/forms';

function FileComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.editing && ctx_r1.required ? "required" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.label);
} }
function FileComponent_div_5_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵlistener("click", function FileComponent_div_5_button_1_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.openInput($event); });
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.textSelect);
} }
function FileComponent_div_5_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵlistener("click", function FileComponent_div_5_div_4_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.download(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r11.textDownload);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r11.file.name, " ");
} }
function FileComponent_div_5_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r12.textNoFileSelected, "");
} }
function FileComponent_div_5_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵlistener("click", function FileComponent_div_5_div_4_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.delete(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r13.textDelete);
} }
function FileComponent_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtemplate(1, FileComponent_div_5_div_4_div_1_Template, 2, 2, "div", 13);
    ɵngcc0.ɵɵtemplate(2, FileComponent_div_5_div_4_div_2_Template, 2, 1, "div", 14);
    ɵngcc0.ɵɵtemplate(3, FileComponent_div_5_div_4_div_3_Template, 1, 1, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.file == null ? null : ctx_r6.file.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r6.file || !ctx_r6.file.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.file == null ? null : ctx_r6.file.name);
} }
function FileComponent_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelement(1, "span", 20);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.textLoading);
} }
function FileComponent_div_5_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "small", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.errorMsg);
} }
function FileComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, FileComponent_div_5_button_1_Template, 3, 1, "button", 5);
    ɵngcc0.ɵɵelementStart(2, "input", 6, 7);
    ɵngcc0.ɵɵlistener("click", function FileComponent_div_5_Template_input_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r19); const _r5 = ɵngcc0.ɵɵreference(3); return _r5.value = null; })("uploadOutput", function FileComponent_div_5_Template_input_uploadOutput_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.onUploadOutput($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, FileComponent_div_5_div_4_Template, 4, 3, "div", 8);
    ɵngcc0.ɵɵtemplate(5, FileComponent_div_5_div_5_Template, 4, 1, "div", 9);
    ɵngcc0.ɵɵtemplate(6, FileComponent_div_5_div_6_Template, 3, 1, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r2.file == null ? null : ctx_r2.file.name) || !ctx_r2.hideButtonIfFileExists);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "fileInput", ctx_r2.uniqueId, "");
    ɵngcc0.ɵɵproperty("options", ctx_r2.options)("accept", ctx_r2.options.allowedContentTypes)("uploadInput", ctx_r2.uploadInput);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.loadingFile);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.loadingFile);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.errorMsg);
} }
function FileComponent_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "-");
    ɵngcc0.ɵɵelementEnd();
} }
function FileComponent_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", 25);
    ɵngcc0.ɵɵlistener("click", function FileComponent_div_6_div_2_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.download(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r22.file.name);
} }
function FileComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵtemplate(1, FileComponent_div_6_div_1_Template, 2, 0, "div", 24);
    ɵngcc0.ɵɵtemplate(2, FileComponent_div_6_div_2_Template, 3, 1, "div", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r3.file == null ? null : ctx_r3.file.name));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r3.file == null ? null : ctx_r3.file.name) && (ctx_r3.file == null ? null : ctx_r3.file.id));
} }
const _c0 = [[["fw-label"]]];
const _c1 = ["fw-label"];
const _c2 = ["angularCropper"];
function ImageCropperComponent_angular_cropper_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "angular-cropper", 11, 12);
    ɵngcc0.ɵɵlistener("ready", function ImageCropperComponent_angular_cropper_8_Template_angular_cropper_ready_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.hideSpinner(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("cropperOptions", ctx_r0.cropperOptions)("imageUrl", ctx_r0.imageUrl);
} }
const _c3 = ["imageInput"];
function ImageComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵlistener("click", function ImageComponent_div_0_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.delete(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r2.textDelete);
} }
function ImageComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, ImageComponent_div_0_div_1_Template, 1, 1, "div", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.image == null ? null : ctx_r0.image.name);
} }
function ImageComponent_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelement(1, "span", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.textLoading, "");
} }
const _c4 = function (a0, a1, a2) { return { "-webkit-border-radius.px": a0, " -moz-border-radius.px": a1, "font-size.px": a2 }; };
function ImageComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "input", 9, 10);
    ɵngcc0.ɵɵlistener("change", function ImageComponent_div_3_Template_input_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onUpload($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p");
    ɵngcc0.ɵɵelementStart(5, "label", 11);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, ImageComponent_div_3_div_7_Template, 3, 1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "imageInput", ctx_r1.uniqueIdentifier, "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵstyleProp("width", ctx_r1.width, "px")("height", ctx_r1.buttonOut ? 20 : ctx_r1.height, "px");
    ɵngcc0.ɵɵpropertyInterpolate1("for", "imageInput", ctx_r1.uniqueIdentifier, "");
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction3(9, _c4, ctx_r1.borderRadius, ctx_r1.borderRadius, ctx_r1.fontSize));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.textChange);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.loading);
} }
function ImageFreeComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 7);
    ɵngcc0.ɵɵlistener("click", function ImageFreeComponent_a_3_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.openInput(); });
    ɵngcc0.ɵɵelement(1, "i");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r0.editIconClass);
} }
function ImageFreeComponent_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵlistener("click", function ImageFreeComponent_a_4_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.delete(); });
    ɵngcc0.ɵɵelement(1, "i");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r1.textDelete);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r1.deleteIconClass);
} }
function ImageFreeComponent_input_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 9, 10);
    ɵngcc0.ɵɵlistener("change", function ImageFreeComponent_input_5_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onUpload($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate1("id", "imageInput", ctx_r2.uniqueIdentifier, "");
} }
function ImageFreeComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.textLoading, "");
} }
function VideoComponent_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r0.getVideoPoster(), ɵngcc0.ɵɵsanitizeUrl);
} }
function VideoComponent_video_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "video", 4);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r1.videoPath, ɵngcc0.ɵɵsanitizeUrl);
} }
function VideoComponent_div_4_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.video.name, " ");
} }
function VideoComponent_div_4_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.textNoFileSelected);
} }
function VideoComponent_div_4_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵlistener("click", function VideoComponent_div_4_div_5_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.delete(); });
    ɵngcc0.ɵɵelementEnd();
} }
function VideoComponent_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, VideoComponent_div_4_div_5_div_1_Template, 2, 1, "div", 10);
    ɵngcc0.ɵɵtemplate(2, VideoComponent_div_4_div_5_div_2_Template, 2, 1, "div", 11);
    ɵngcc0.ɵɵtemplate(3, VideoComponent_div_4_div_5_div_3_Template, 1, 0, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.video == null ? null : ctx_r3.video.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.video || !ctx_r3.video.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.video == null ? null : ctx_r3.video.name);
} }
function VideoComponent_div_4_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelement(1, "span", 17);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.textLoading);
} }
function VideoComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "button", 5);
    ɵngcc0.ɵɵlistener("click", function VideoComponent_div_4_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.abrirInput($event); });
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 6);
    ɵngcc0.ɵɵlistener("uploadOutput", function VideoComponent_div_4_Template_input_uploadOutput_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onUploadOutput($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, VideoComponent_div_4_div_5_Template, 4, 3, "div", 7);
    ɵngcc0.ɵɵtemplate(6, VideoComponent_div_4_div_6_Template, 4, 1, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.textSelect, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "inputVideo", ctx_r2.uniqueIdentifier, "");
    ɵngcc0.ɵɵproperty("options", ctx_r2.options)("uploadInput", ctx_r2.uploadInput);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.loadingVideo);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.loadingVideo);
} }
class FwFilesConfig {
    constructor() {
        this.i18n = {};
    }
}
FwFilesConfig.ɵfac = function FwFilesConfig_Factory(t) { return new (t || FwFilesConfig)(); };
FwFilesConfig.ɵprov = ɵɵdefineInjectable({ factory: function FwFilesConfig_Factory() { return new FwFilesConfig(); }, token: FwFilesConfig, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwFilesConfig, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

class FwFileDTO {
}
class FilesService {
    constructor(config, http) {
        this.config = config;
        this.http = http;
    }
    /**
     * Obtiene el objeto que utiliza ngx-upload para persitir el archivo temporal
     * @returns UploadInput
     */
    createUploadInput() {
        const event = {
            type: 'uploadAll',
            url: this.config.urlCreateArchivoTemporal,
            method: 'POST'
        };
        return event;
    }
    /**
     * Crea un nuevo dto fichero a partir de la respuesta del evento de generación de ficheros
     * @param UploadOutput output
     * @returns FicheroDTO
     */
    createFichero(output) {
        let file = null;
        if (output.file.responseStatus === 200 || output.file.responseStatus === 201) { // Or whatever your return code status is
            if (!file) {
                file = new FwFileDTO();
            }
            file.id = null;
            file.temporalFileName = output.file.response;
            file.name = output.file.name;
        }
        return file;
    }
    getTemporalFileName() {
        return this.config.urlFicheroTemporal;
    }
    downloadFile(temporalFileName, fileName) {
        window.location.assign(this.getTemporalFileName() + '/' + temporalFileName + '?fileName=' + fileName);
    }
    getUrlImageDefault() {
        return this.config.urlImagenDefault;
    }
    getUrlVideoPosterDefault() {
        return this.config.urlVideoPosterDefault;
    }
    uploadFile(file) {
        const formData = new FormData();
        formData.append('file', file);
        const req = new HttpRequest('POST', this.config.urlCreateArchivoTemporal, formData, { responseType: 'text' });
        return this.http.request(req);
    }
}
FilesService.ɵfac = function FilesService_Factory(t) { return new (t || FilesService)(ɵngcc0.ɵɵinject(FwFilesConfig), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
FilesService.ɵprov = ɵɵdefineInjectable({ factory: function FilesService_Factory() { return new FilesService(ɵɵinject(FwFilesConfig), ɵɵinject(HttpClient)); }, token: FilesService, providedIn: "root" });
FilesService.ctorParameters = () => [
    { type: FwFilesConfig },
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilesService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: FwFilesConfig }, { type: ɵngcc1.HttpClient }]; }, null); })();

class FileComponent {
    constructor(required, filesService) {
        this.filesService = filesService;
        this.textSelect = this.filesService.config.i18n.fileSelect || 'Select file';
        this.textLoading = this.filesService.config.i18n.fileLoading || 'Loading';
        this.textNoFileSelected = this.filesService.config.i18n.fileNoFileSelected || 'No file selected';
        this.textDownload = this.filesService.config.i18n.fileDownload || 'Download';
        this.textDelete = this.filesService.config.i18n.fileDelete || 'Delete';
        this.genericError = this.filesService.config.i18n.genericError || 'An error occurred';
        this.unsupportedFileError = this.filesService.config.i18n.unsupportedFileError || 'Unsupported file extension';
        /* the method set in registerOnChange, it is just
         a placeholder for a method that takes one parameter,
         we use it to emit changes back to the form */
        this.propagateChange = (_) => {
        };
        this.options = { concurrency: 1, maxUploads: 3 };
        this.uploadInput = new EventEmitter(); // input events, we use this to emit data to ngx-uploader
        this.uniqueId = this.newGuid();
        // FIXME Estamos usando este required para saber si mostrar el asterisco... ¿funciona el attribute si es una valor dinámico?
        this.required = required !== null; // Si ponemos "required" el valor es undefined.
    }
    ngOnInit() {
        if (this.unlimitedUploads) {
            delete this.options.maxUploads;
        }
        if (this.allowedContentTypes) {
            this.options.allowedContentTypes = this.allowedContentTypes;
        }
    }
    openInput(element) {
        document.getElementById('fileInput' + this.uniqueId).click();
        element.currentTarget.blur();
    }
    download() {
        if (this.file.id) {
            window.location.assign(this.persistentFileUrl);
        }
        else {
            window.location.assign(this.filesService.getTemporalFileName() + '/' + this.file.temporalFileName + '?fileName=' + this.file.name);
        }
    }
    delete() {
        this.file = null;
        this.propagateChange(this.file);
    }
    onUploadOutput(output) {
        var _a, _b, _c, _d, _e;
        if (output.type === 'allAddedToQueue') { // when all files added in queue TODO La url debería configurarse a nivel de módulo
            const event = this.filesService.createUploadInput();
            this.uploadInput.emit(event);
        }
        else {
            this.errorMsg = null;
            if (output.type === 'rejected' && typeof output.file !== 'undefined') {
                this.errorMsg = this.unsupportedFileError;
                this.delete();
            }
            else if (output.type === 'uploading') {
                this.loadingFile = ((_b = (_a = output.file) === null || _a === void 0 ? void 0 : _a.progress) === null || _b === void 0 ? void 0 : _b.status) !== UploadStatus.Cancelled && ((_d = (_c = output.file) === null || _c === void 0 ? void 0 : _c.progress) === null || _d === void 0 ? void 0 : _d.status) !== UploadStatus.Done;
            }
            else if (output.type === 'done') {
                this.loadingFile = false;
                switch (output.file.responseStatus) {
                    case 200:
                        this.file = this.filesService.createFichero(output);
                        this.propagateChange(this.file);
                        break;
                    case 409:
                        this.errorMsg = output.file.response.message;
                        this.delete();
                        break;
                    default:
                        this.errorMsg = this.genericError;
                        this.delete();
                        break;
                }
                this.uploadInput.emit({ type: 'remove', id: (_e = output.file) === null || _e === void 0 ? void 0 : _e.id });
            }
        }
    }
    /* registers 'fn' that will be fired when changes are made. This is how we emit the changes back to the form */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched(fn) {
    }
    setDisabledState(isDisabled) {
    }
    writeValue(obj) {
        this.file = obj;
    }
    registerOnValidatorChange(fn) {
    }
    validate(c) {
        return (!this.loadingFile) ? null : {
            cargandoFichero: { valid: false }
        };
    }
    newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            // tslint:disable-next-line:no-bitwise
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
FileComponent.ɵfac = function FileComponent_Factory(t) { return new (t || FileComponent)(ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵdirectiveInject(FilesService)); };
FileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FileComponent, selectors: [["fw-file"]], inputs: { label: "label", editing: "editing", persistentFileUrl: "persistentFileUrl", hideButtonIfFileExists: "hideButtonIfFileExists", allowedContentTypes: "allowedContentTypes", unlimitedUploads: "unlimitedUploads" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => FileComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => FileComponent),
                multi: true
            }
        ])], ngContentSelectors: _c1, decls: 7, vars: 3, consts: [["ref", ""], [3, "class", 4, "ngIf"], ["class", "file-edit", 4, "ngIf"], ["class", "fichero-lectura", 4, "ngIf"], [1, "file-edit"], ["type", "button", "class", "btn btn-secondary boton-seleccionar-archivo", 3, "click", 4, "ngIf"], ["type", "file", "ngFileSelect", "", "required", "", 1, "input-fichero", 3, "id", "options", "accept", "uploadInput", "click", "uploadOutput"], ["uploadFile", ""], ["class", "descripcion-archivo", 4, "ngIf"], ["class", "mensaje-cargando", 4, "ngIf"], ["class", "validation", 4, "ngIf"], ["type", "button", 1, "btn", "btn-secondary", "boton-seleccionar-archivo", 3, "click"], [1, "descripcion-archivo"], ["class", "nombre-archivo-descargar-edicion", 3, "title", "click", 4, "ngIf"], ["class", "mensaje-no-hay-fichero", 4, "ngIf"], ["class", "fa fa-times icono-eliminar", 3, "title", "click", 4, "ngIf"], [1, "nombre-archivo-descargar-edicion", 3, "title", "click"], [1, "mensaje-no-hay-fichero"], [1, "fa", "fa-times", "icono-eliminar", 3, "title", "click"], [1, "mensaje-cargando"], [1, "fa", "fa-spinner", "fa-spin"], [1, "validation"], [1, "form-text", "text-danger"], [1, "fichero-lectura"], [4, "ngIf"], [1, "nombre-archivo-descargar", 3, "click"]], template: function FileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", null, 0);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, FileComponent_label_4_Template, 2, 3, "label", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, FileComponent_div_5_Template, 7, 8, "div", 2);
        ɵngcc0.ɵɵtemplate(6, FileComponent_div_6_Template, 3, 2, "div", 3);
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label && !_r0.innerHTML.trim());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.NgFileSelectDirective], styles: [".input-fichero[_ngcontent-%COMP%]{display:none!important;width:0}.nombre-archivo-descargar[_ngcontent-%COMP%], .nombre-archivo-descargar-edicion[_ngcontent-%COMP%]{color:#20a8d8;cursor:pointer;font-weight:400;float:left}.nombre-archivo-descargar-edicion[_ngcontent-%COMP%]{margin-top:6px}.boton-seleccionar-archivo[_ngcontent-%COMP%]{margin-right:5px;float:left}.icono-eliminar[_ngcontent-%COMP%]{margin-top:8px;font-size:16px;margin-left:5px;color:#8b0000;cursor:pointer;float:left}.mensaje-no-hay-fichero[_ngcontent-%COMP%]{margin-top:5px;float:left}.mensaje-cargando[_ngcontent-%COMP%]{margin-top:7px;float:left}.descripcion-archivo[_ngcontent-%COMP%], .fichero-lectura[_ngcontent-%COMP%]{float:left}.validation[_ngcontent-%COMP%]{display:inline-block;width:100%}"] });
FileComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: FilesService }
];
FileComponent.propDecorators = {
    label: [{ type: Input }],
    editing: [{ type: Input }],
    persistentFileUrl: [{ type: Input }],
    hideButtonIfFileExists: [{ type: Input }],
    allowedContentTypes: [{ type: Input }],
    unlimitedUploads: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileComponent, [{
        type: Component,
        args: [{
                selector: 'fw-file',
                template: "<div>\r\n    <div #ref>\r\n        <ng-content select=\"fw-label\"></ng-content>\r\n    </div>\r\n    <label *ngIf=\"label && !ref.innerHTML.trim()\" [class]=\"editing && required? 'required': ''\">{{label}}</label>\r\n</div>\r\n\r\n<div *ngIf=\"editing\" class=\"file-edit\">\r\n    <button type=\"button\" class=\"btn btn-secondary boton-seleccionar-archivo\"\r\n            *ngIf=\"!(file?.name) || !hideButtonIfFileExists\"\r\n            (click)=\"openInput($event)\">\r\n        <span>{{textSelect}}</span>\r\n    </button>\r\n\r\n    <input id=\"fileInput{{uniqueId}}\" type=\"file\" class=\"input-fichero\" ngFileSelect required\r\n           [options]=\"options\"\r\n           [accept]=\"options.allowedContentTypes\"\r\n           (click)=\"uploadFile.value = null\"\r\n           #uploadFile\r\n           (uploadOutput)=\"onUploadOutput($event)\" [uploadInput]=\"uploadInput\">\r\n\r\n    <div *ngIf=\"!loadingFile\" class=\"descripcion-archivo\">\r\n        <div *ngIf=\"file?.name\" class=\"nombre-archivo-descargar-edicion\" title=\"{{textDownload}}\" (click)=\"download()\">\r\n            {{file.name}}\r\n        </div>\r\n\r\n        <div *ngIf=\"!file || !file.name\" class=\"mensaje-no-hay-fichero\"> {{textNoFileSelected}}</div>\r\n\r\n        <div *ngIf=\"file?.name\" class=\"fa fa-times icono-eliminar\"\r\n             (click)=\"delete()\" title=\"{{textDelete}}\"></div>\r\n    </div>\r\n    <div *ngIf=\"loadingFile\" class=\"mensaje-cargando\">\r\n        <span class=\"fa fa-spinner fa-spin\"></span> <span>{{textLoading}}</span></div>\r\n\r\n    <div class=\"validation\" *ngIf=\"errorMsg\">\r\n        <small class=\"form-text text-danger\">{{errorMsg}}</small>\r\n    </div>\r\n</div>\r\n\r\n<div *ngIf=\"!editing\" class=\"fichero-lectura\">\r\n    <div *ngIf=\"!file?.name\">-</div>\r\n    <div *ngIf=\"file?.name && file?.id\">\r\n        <span class=\"nombre-archivo-descargar\" (click)=\"download()\">{{file.name}}</span>\r\n    </div>\r\n</div>\r\n\r\n\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => FileComponent),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => FileComponent),
                        multi: true
                    }
                ],
                styles: [".input-fichero{display:none!important;width:0}.nombre-archivo-descargar,.nombre-archivo-descargar-edicion{color:#20a8d8;cursor:pointer;font-weight:400;float:left}.nombre-archivo-descargar-edicion{margin-top:6px}.boton-seleccionar-archivo{margin-right:5px;float:left}.icono-eliminar{margin-top:8px;font-size:16px;margin-left:5px;color:#8b0000;cursor:pointer;float:left}.mensaje-no-hay-fichero{margin-top:5px;float:left}.mensaje-cargando{margin-top:7px;float:left}.descripcion-archivo,.fichero-lectura{float:left}.validation{display:inline-block;width:100%}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: FilesService }]; }, { label: [{
            type: Input
        }], editing: [{
            type: Input
        }], persistentFileUrl: [{
            type: Input
        }], hideButtonIfFileExists: [{
            type: Input
        }], allowedContentTypes: [{
            type: Input
        }], unlimitedUploads: [{
            type: Input
        }] }); })();

class ImageCropperComponent {
    constructor(activeModal, spinner, config) {
        this.activeModal = activeModal;
        this.spinner = spinner;
        this.config = config;
        this.isDisable = true;
        this.textTitle = this.config.i18n.imageCropTitle || 'Place and resize the image';
        this.textAccept = this.config.i18n.accept || 'Accept';
        this.textCancel = this.config.i18n.cancel || 'Cancel';
    }
    ngOnInit() {
        this.spinner.show();
        const aspectRatio = !this.width || !this.height ? null : this.width / this.height;
        this.cropperOptions = { aspectRatio, dragMode: 'none', autoCropArea: 1 };
        const myReader = new FileReader();
        const that = this;
        myReader.readAsDataURL(this.file);
        myReader.addEventListener('loadend', function (loadEvent) {
            that.imageUrl = loadEvent.target.result;
        });
    }
    accept() {
        // fillColor -> blanco si no hay color de fondo al generar el .jpeg
        this.activeModal.close(this.angularCropper.cropper.getCroppedCanvas({ fillColor: '#fff' }).toDataURL('image/jpeg'));
    }
    cancel() {
        this.activeModal.close(false);
    }
    hideSpinner() {
        this.spinner.hide();
        this.isDisable = false;
    }
}
ImageCropperComponent.ɵfac = function ImageCropperComponent_Factory(t) { return new (t || ImageCropperComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgxSpinnerService), ɵngcc0.ɵɵdirectiveInject(FwFilesConfig)); };
ImageCropperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ImageCropperComponent, selectors: [["fw-image-cropper"]], viewQuery: function ImageCropperComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.angularCropper = _t.first);
    } }, inputs: { file: "file", width: "width", height: "height" }, decls: 16, vars: 5, consts: [[1, "modal-header"], [1, "modal-title"], ["type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"], ["id", "cropperBody", 1, "modal-body"], [1, "wrapper-imagen"], ["style", "max-height:200px", 3, "cropperOptions", "imageUrl", "ready", 4, "ngIf"], ["bdColor", "rgba(51, 51, 51, 0.8)", "size", "large", "color", "#fff", "type", "ball-pulse"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-primary", 3, "disabled", "click"], ["type", "button", 1, "btn", "btn-danger", 3, "click"], [2, "max-height", "200px", 3, "cropperOptions", "imageUrl", "ready"], ["angularCropper", ""]], template: function ImageCropperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h4", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 2);
        ɵngcc0.ɵɵlistener("click", function ImageCropperComponent_Template_button_click_3_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵtext(5, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵtemplate(8, ImageCropperComponent_angular_cropper_8_Template, 2, 2, "angular-cropper", 6);
        ɵngcc0.ɵɵelement(9, "br");
        ɵngcc0.ɵɵelement(10, "ngx-spinner", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "button", 9);
        ɵngcc0.ɵɵlistener("click", function ImageCropperComponent_Template_button_click_12_listener() { return ctx.accept(); });
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "button", 10);
        ɵngcc0.ɵɵlistener("click", function ImageCropperComponent_Template_button_click_14_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.textTitle);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.imageUrl);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("disabled", ctx.isDisable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.textAccept);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.textCancel);
    } }, directives: [ɵngcc2.NgIf, ɵngcc5.NgxSpinnerComponent, ɵngcc6.CropperComponent], styles: [""] });
ImageCropperComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: NgxSpinnerService },
    { type: FwFilesConfig }
];
ImageCropperComponent.propDecorators = {
    file: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    angularCropper: [{ type: ViewChild, args: ['angularCropper',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImageCropperComponent, [{
        type: Component,
        args: [{
                selector: 'fw-image-cropper',
                template: "<div class=\"modal-header\">\r\n    <h4 class=\"modal-title\">{{textTitle}}</h4>\r\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cancel()\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n</div>\r\n<div class=\"modal-body\" id=\"cropperBody\">\r\n    <div class=\"wrapper-imagen\">\r\n        <angular-cropper #angularCropper [cropperOptions]=\"cropperOptions\" [imageUrl]=\"imageUrl\" *ngIf=\"imageUrl\"\r\n                         style=\"max-height:200px\" (ready)=\"hideSpinner()\"></angular-cropper>\r\n        <br>\r\n        <ngx-spinner bdColor=\"rgba(51, 51, 51, 0.8)\" size=\"large\" color=\"#fff\" type=\"ball-pulse\"></ngx-spinner>\r\n    </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"accept()\" [disabled]=\"isDisable\">{{textAccept}}</button>\r\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"cancel()\">{{textCancel}}</button>\r\n</div>\r\n\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc4.NgbActiveModal }, { type: ɵngcc5.NgxSpinnerService }, { type: FwFilesConfig }]; }, { file: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], angularCropper: [{
            type: ViewChild,
            args: ['angularCropper']
        }] }); })();

class ImageComponent {
    constructor(ficherosService, modalService) {
        this.ficherosService = ficherosService;
        this.modalService = modalService;
        this.mainClass = 'image-container';
        this.crop = false;
        this.border = true;
        this.loadingChange = new EventEmitter();
        this.removable = true;
        this.textChange = this.ficherosService.config.i18n.imageChange || 'Change';
        this.textLoading = this.ficherosService.config.i18n.imageLoading || 'Loading';
        this.textDelete = this.ficherosService.config.i18n.fileDelete || 'Delete';
        /* the method set in registerOnChange, it is just
         a placeholder for a method that takes one parameter,
         we use it to emit changes back to the form */
        this.propagateChange = (_) => {
        };
        if (this.uniqueIdentifier == null) {
            this.uniqueIdentifier = 1;
        }
    }
    ngOnInit() {
        this.width = this.width == null ? 350 : this.width;
        this.height = this.height == null ? 350 : this.height;
        if (this.containerClass) {
            this.mainClass = this.mainClass + ' ' + this.containerClass;
        }
        if (this.width > 150) {
            this.fontSize = 15;
        }
        else {
            this.fontSize = 10;
        }
        this.borderRadius = this.width != null ? this.width / 2 : 100;
        if (this.editing === undefined) {
            this.editing = true;
        }
        if (this.crop === undefined) {
            this.crop = false;
        }
        if (this.shape === 'RECTANGULO') {
            this.borderRadius = 0;
        }
        else {
            this.borderRadius = this.width != null ? this.width / 2 : 100;
        }
    }
    abrirInput(element) {
        document.getElementById('imageInput' + this.uniqueIdentifier).click();
        element.currentTarget.blur();
    }
    getPathImage(imagen) {
        if (imagen && imagen.id) {
            // The id is sent in order to facilitate the caching
            return this.persistentFileUrl + '?id=' + this.image.id;
        }
        else {
            return this.defaultImagePath || this.ficherosService.getUrlImageDefault();
        }
    }
    delete() {
        this.image = null;
        this.propagateChange(this.image);
        this.pathImage = this.getPathImage(this.image);
    }
    onUpload(event) {
        this.file = event.target.files[0];
        if (this.crop) {
            this.openImageCropper();
        }
        else {
            this.updateFile(this.file);
        }
    }
    generateThumb(file) {
        if (file != null) {
            if (file.type.indexOf('image') > -1) {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                const fileReader$ = fromEvent(fileReader, 'load').subscribe(result => {
                    this.pathImage = fileReader.result;
                });
            }
        }
    }
    /* registers 'fn' that will be fired when changes are made. This is how we emit the changes back to the form */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched(fn) {
    }
    setDisabledState(isDisabled) {
    }
    writeValue(obj) {
        this.image = obj;
        this.pathImage = this.getPathImage(this.image);
    }
    openImageCropper() {
        const modalRef = this.modalService.open(ImageCropperComponent, {
            size: 'lg',
            backdrop: 'static',
            centered: true,
            windowClass: 'text-center custom-image-modal'
        });
        modalRef.componentInstance.file = this.file;
        modalRef.componentInstance.width = this.cropperWidth ? this.cropperWidth : this.width;
        modalRef.componentInstance.height = this.cropperHeight ? this.cropperHeight : this.height;
        modalRef.result.then(result => {
            if (result) {
                const file = this.base64URIToFile(result, this.file.name, this.file.type);
                this.updateFile(file);
            }
            else {
                this.imageInput.nativeElement.value = '';
            }
        });
    }
    updateFile(file) {
        this.loading = true;
        this.loadingChange.emit(true);
        this.generateThumb(file);
        this.ficherosService.uploadFile(file).subscribe(event => {
            if (event.type === 4) {
                this.image = new FwFileDTO;
                this.image.temporalFileName = event.body;
                this.image.name = this.file.name;
                this.propagateChange(this.image);
                this.loading = false;
                this.loadingChange.emit(false);
            }
            this.imageInput.nativeElement.value = '';
        }, () => {
            this.loading = false;
            this.loadingChange.emit(false);
        });
    }
    base64URIToFile(base64Str, nombre, tipo) {
        const byteString = atob(base64Str.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        const file = new File([ab], nombre, { type: tipo });
        return file;
    }
}
ImageComponent.ɵfac = function ImageComponent_Factory(t) { return new (t || ImageComponent)(ɵngcc0.ɵɵdirectiveInject(FilesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbModal)); };
ImageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ImageComponent, selectors: [["fw-image"]], viewQuery: function ImageComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.imageInput = _t.first);
    } }, inputs: { crop: "crop", border: "border", removable: "removable", textChange: "textChange", textLoading: "textLoading", textDelete: "textDelete", uniqueIdentifier: "uniqueIdentifier", width: "width", height: "height", editing: "editing", loading: "loading", persistentFileUrl: "persistentFileUrl", defaultImagePath: "defaultImagePath", cropperWidth: "cropperWidth", cropperHeight: "cropperHeight", shape: "shape", containerClass: "containerClass", buttonOut: "buttonOut" }, outputs: { loadingChange: "loadingChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => ImageComponent),
                multi: true
            },
        ])], decls: 4, vars: 13, consts: [["class", "eliminar-imagen", 4, "ngIf"], [1, "contenedor-imagen"], [1, "img-thumbnail", "img-responsive", "image-cover", "p-0", 3, "src"], ["class", "seleccion-imagen", 4, "ngIf"], [1, "eliminar-imagen"], ["class", "fa fa-times icono-eliminar", 3, "title", "click", 4, "ngIf"], [1, "fa", "fa-times", "icono-eliminar", 3, "title", "click"], [1, "seleccion-imagen"], [1, "image-selector"], ["type", "file", "accept", "image/*", 1, "form-control-file", "input-file", 3, "id", "change"], ["imageInput", ""], [3, "ngStyle", "for"], ["class", "mensaje-cargando", 4, "ngIf"], [1, "mensaje-cargando"], [1, "fa", "fa-spinner", "fa-spin"]], template: function ImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ImageComponent_div_0_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "img", 2);
        ɵngcc0.ɵɵtemplate(3, ImageComponent_div_3_Template, 8, 13, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loading && ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("boton-fuera", ctx.buttonOut);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("border-radius", ctx.borderRadius, "px")("width", ctx.width, "px")("height", ctx.height, "px")("border", ctx.border);
        ɵngcc0.ɵɵproperty("src", ctx.pathImage, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgStyle], styles: ["[_nghost-%COMP%]{position:relative}.image-container[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:0}.eliminar-imagen[_ngcontent-%COMP%]{right:0;z-index:1}.eliminar-imagen[_ngcontent-%COMP%], .image-selector[_ngcontent-%COMP%]{position:absolute;top:0}input[_ngcontent-%COMP%]:focus{outline:none}.input-file[_ngcontent-%COMP%]{display:none}.input-file[_ngcontent-%COMP%] + p[_ngcontent-%COMP%]{margin-bottom:0;text-align:center}.input-file[_ngcontent-%COMP%] + p[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{padding:2%;display:table-cell;vertical-align:bottom;color:#fff;cursor:pointer;background:linear-gradient(180deg,transparent 85%,rgba(0,0,0,.45) 0,rgba(0,0,0,.45))}[_nghost-%COMP%]{display:inline-block}.input-fichero[_ngcontent-%COMP%]{display:none!important;width:0}.nombre-archivo-descargar[_ngcontent-%COMP%]{color:#20a8d8;cursor:pointer;font-weight:400;margin-top:5px}.boton-seleccionar-archivo[_ngcontent-%COMP%]{margin-right:5px}.icono-eliminar[_ngcontent-%COMP%]{margin-top:8px;font-size:24px;margin-left:5px;color:#8b0000;cursor:pointer;float:left}.mensaje-no-hay-fichero[_ngcontent-%COMP%]{margin-top:5px}.mensaje-cargando[_ngcontent-%COMP%]{margin-top:7px;float:left}.vista-imagen[_ngcontent-%COMP%]{width:100%;height:100%}.boton-fuera[_ngcontent-%COMP%]   .image-selector[_ngcontent-%COMP%]{position:relative;top:0}.boton-fuera[_ngcontent-%COMP%]   .input-file[_ngcontent-%COMP%]{display:none}.boton-fuera[_ngcontent-%COMP%]   .input-file[_ngcontent-%COMP%] + p[_ngcontent-%COMP%]{margin-bottom:0;text-align:center}.boton-fuera[_ngcontent-%COMP%]   .input-file[_ngcontent-%COMP%] + p[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{padding:3px;display:table-cell;vertical-align:bottom;color:#fff;background:rgba(0,0,0,.45) 85%;cursor:pointer}@media only screen and (max-width:900px){.custom-image-modal[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{min-width:100%;min-height:100vh;margin:0;padding:0}.custom-image-modal[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{min-width:100%;min-height:100vh}.custom-image-modal[_ngcontent-%COMP%]   fw-image-cropper[_ngcontent-%COMP%]{min-height:100vh}.custom-image-modal[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%]{padding:0}.custom-image-modal[_ngcontent-%COMP%]   canvas[_ngcontent-%COMP%]{width:100%}}@media only screen and (max-width:900px) and (orientation:landscape){.custom-image-modal[_ngcontent-%COMP%]   canvas[_ngcontent-%COMP%]{height:220px}}"] });
ImageComponent.ctorParameters = () => [
    { type: FilesService },
    { type: NgbModal }
];
ImageComponent.propDecorators = {
    uniqueIdentifier: [{ type: Input }],
    persistentFileUrl: [{ type: Input }],
    defaultImagePath: [{ type: Input }],
    editing: [{ type: Input }],
    crop: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    cropperWidth: [{ type: Input }],
    cropperHeight: [{ type: Input }],
    shape: [{ type: Input }],
    border: [{ type: Input }],
    containerClass: [{ type: Input }],
    loading: [{ type: Input }],
    loadingChange: [{ type: Output }],
    removable: [{ type: Input }],
    buttonOut: [{ type: Input }],
    textChange: [{ type: Input }],
    textLoading: [{ type: Input }],
    textDelete: [{ type: Input }],
    imageInput: [{ type: ViewChild, args: ['imageInput',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImageComponent, [{
        type: Component,
        args: [{
                selector: 'fw-image',
                template: "<div *ngIf=\"!loading && editing\" class=\"eliminar-imagen\">\r\n    <div *ngIf=\"image?.name\" class=\"fa fa-times icono-eliminar\" (click)=\"delete()\" title=\"{{textDelete}}\"></div>\r\n</div>\r\n<div [class.boton-fuera]=\"buttonOut\" class=\"contenedor-imagen\">\r\n    <img [src]=\"pathImage\" class=\"img-thumbnail img-responsive image-cover p-0\" [style.borderRadius.px]=\"borderRadius\"\r\n         [style.width.px]=\"width\" [style.height.px]=\"height\" [style.border]=\"border\">\r\n\r\n    <div *ngIf=\"editing\" class=\"seleccion-imagen\">\r\n        <div class=\"image-selector\">\r\n            <input class=\"form-control-file input-file\" #imageInput id=\"imageInput{{uniqueIdentifier}}\" type=\"file\"\r\n                   accept=\"image/*\"\r\n                   (change)=\"onUpload($event)\">\r\n            <p>\r\n                <label [style.width.px]=\"width\" [style.height.px]=\"buttonOut ? 20 : height\" [ngStyle]=\"{\r\n                            '-webkit-border-radius.px': borderRadius,\r\n                            ' -moz-border-radius.px': borderRadius,\r\n                            'font-size.px': fontSize}\"\r\n                       for=\"imageInput{{uniqueIdentifier}}\">{{textChange}}</label>\r\n            </p>\r\n        </div>\r\n        <div *ngIf=\"loading\" class=\"mensaje-cargando\">\r\n            <span class=\"fa fa-spinner fa-spin\"></span> {{textLoading}}</div>\r\n    </div>\r\n</div>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => ImageComponent),
                        multi: true
                    },
                ],
                styles: [":host{position:relative}.image-container p{margin-bottom:0}.eliminar-imagen{right:0;z-index:1}.eliminar-imagen,.image-selector{position:absolute;top:0}input:focus{outline:none}.input-file{display:none}.input-file+p{margin-bottom:0;text-align:center}.input-file+p label{padding:2%;display:table-cell;vertical-align:bottom;color:#fff;cursor:pointer;background:linear-gradient(180deg,transparent 85%,rgba(0,0,0,.45) 0,rgba(0,0,0,.45))}:host{display:inline-block}.input-fichero{display:none!important;width:0}.nombre-archivo-descargar{color:#20a8d8;cursor:pointer;font-weight:400;margin-top:5px}.boton-seleccionar-archivo{margin-right:5px}.icono-eliminar{margin-top:8px;font-size:24px;margin-left:5px;color:#8b0000;cursor:pointer;float:left}.mensaje-no-hay-fichero{margin-top:5px}.mensaje-cargando{margin-top:7px;float:left}.vista-imagen{width:100%;height:100%}.boton-fuera .image-selector{position:relative;top:0}.boton-fuera .input-file{display:none}.boton-fuera .input-file+p{margin-bottom:0;text-align:center}.boton-fuera .input-file+p label{padding:3px;display:table-cell;vertical-align:bottom;color:#fff;background:rgba(0,0,0,.45) 85%;cursor:pointer}@media only screen and (max-width:900px){.custom-image-modal .modal-dialog{min-width:100%;min-height:100vh;margin:0;padding:0}.custom-image-modal .modal-content{min-width:100%;min-height:100vh}.custom-image-modal fw-image-cropper{min-height:100vh}.custom-image-modal .modal-body{padding:0}.custom-image-modal canvas{width:100%}}@media only screen and (max-width:900px) and (orientation:landscape){.custom-image-modal canvas{height:220px}}"]
            }]
    }], function () { return [{ type: FilesService }, { type: ɵngcc4.NgbModal }]; }, { crop: [{
            type: Input
        }], border: [{
            type: Input
        }], loadingChange: [{
            type: Output
        }], removable: [{
            type: Input
        }], textChange: [{
            type: Input
        }], textLoading: [{
            type: Input
        }], textDelete: [{
            type: Input
        }], uniqueIdentifier: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], editing: [{
            type: Input
        }], loading: [{
            type: Input
        }], persistentFileUrl: [{
            type: Input
        }], defaultImagePath: [{
            type: Input
        }], cropperWidth: [{
            type: Input
        }], cropperHeight: [{
            type: Input
        }], shape: [{
            type: Input
        }], containerClass: [{
            type: Input
        }], buttonOut: [{
            type: Input
        }], imageInput: [{
            type: ViewChild,
            args: ['imageInput']
        }] }); })();

class ImageFreeComponent {
    constructor(required, filesService, modalService) {
        this.filesService = filesService;
        this.modalService = modalService;
        this.maxWidth = 500;
        this.maxHeight = 300;
        this.crop = false;
        this.border = true;
        this.editIconClass = 'fa fa-pencil-alt';
        this.deleteIconClass = 'fa fa-trash-alt';
        this.chargingChange = new EventEmitter();
        this.removable = true;
        this.textChange = this.filesService.config.i18n.imageChange || 'Change';
        this.textLoading = this.filesService.config.i18n.fileLoading || 'Loading';
        this.label = 'Image';
        this.textDelete = this.filesService.config.i18n.fileDelete || 'Delete';
        /* the method set in registerOnChange, it is just
         a placeholder for a method that takes one parameter,
         we use it to emit changes back to the form */
        this.propagateChange = (_) => {
        };
        if (this.uniqueIdentifier == null) {
            this.uniqueIdentifier = 1;
        }
        // FIXME Estamos usando este required para saber si mostrar el asterisco... ¿funciona el attribute si es una valor dinámico?
        this.required = required !== null; // Si ponemos "required" el valor es undefined.
    }
    ngOnInit() {
        if (this.shape === 'RECTANGULO') {
            this.borderRadius = 0;
        }
        else {
            this.borderRadius = this.width != null ? this.width / 2 : 100;
        }
        if (this.editing === undefined) {
            this.editing = true;
        }
    }
    openInput() {
        document.getElementById('imageInput' + this.uniqueIdentifier).click();
    }
    getImagePath(imagen) {
        if (imagen && imagen.id) {
            // El id lo enviamos para facilitar el cacheado
            return this.persistentFileUrl + '?id=' + this.image.id;
        }
        else {
            return this.defaultImagePath || this.filesService.getUrlImageDefault();
        }
    }
    delete() {
        this.image = null;
        this.propagateChange(this.image);
        this.imagePath = this.getImagePath(this.image);
    }
    onUpload(event) {
        this.file = event.target.files[0];
        if (this.crop) {
            this.openImageCropper();
        }
        else {
            this.updateFile(this.file);
        }
    }
    generateThumb(file) {
        if (file != null) {
            if (file.type.indexOf('image') > -1) {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                const fileReader$ = fromEvent(fileReader, 'load').subscribe(result => {
                    this.imagePath = fileReader.result;
                });
            }
        }
    }
    /* registers 'fn' that will be fired when changes are made. This is how we emit the changes back to the form */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched(fn) {
    }
    setDisabledState(isDisabled) {
    }
    writeValue(obj) {
        this.image = obj;
        this.imagePath = this.getImagePath(this.image);
    }
    openImageCropper() {
        const modalRef = this.modalService.open(ImageCropperComponent, {
            size: 'lg',
            backdrop: 'static',
            centered: true,
            windowClass: 'text-center custom-image-modal'
        });
        modalRef.componentInstance.file = this.file;
        modalRef.componentInstance.width = this.width;
        modalRef.componentInstance.height = this.height;
        modalRef.result.then(result => {
            if (result) {
                const file = this.base64URIToFile(result, this.file.name, this.file.type);
                this.updateFile(file);
            }
            else {
                this.imageInput.nativeElement.value = '';
            }
        });
    }
    updateFile(file) {
        this.loading = true;
        this.chargingChange.emit(true);
        this.generateThumb(file);
        this.filesService.uploadFile(file).subscribe(event => {
            if (event.type === 4) {
                this.image = new FwFileDTO;
                this.image.temporalFileName = event.body;
                this.image.name = this.file.name;
                this.propagateChange(this.image);
                this.loading = false;
                this.chargingChange.emit(false);
            }
            this.imageInput.nativeElement.value = '';
        }, () => {
            this.loading = false;
            this.chargingChange.emit(false);
        });
    }
    base64URIToFile(base64Str, nombre, tipo) {
        const byteString = atob(base64Str.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        const file = new File([ab], nombre, { type: tipo });
        return file;
    }
}
ImageFreeComponent.ɵfac = function ImageFreeComponent_Factory(t) { return new (t || ImageFreeComponent)(ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵdirectiveInject(FilesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbModal)); };
ImageFreeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ImageFreeComponent, selectors: [["fw-image-free"]], viewQuery: function ImageFreeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.imageInput = _t.first);
    } }, inputs: { maxWidth: "maxWidth", maxHeight: "maxHeight", crop: "crop", border: "border", editIconClass: "editIconClass", deleteIconClass: "deleteIconClass", removable: "removable", textChange: "textChange", textLoading: "textLoading", label: "label", uniqueIdentifier: "uniqueIdentifier", editing: "editing", loading: "loading", persistentFileUrl: "persistentFileUrl", defaultImagePath: "defaultImagePath", width: "width", height: "height", shape: "shape" }, outputs: { chargingChange: "chargingChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => ImageFreeComponent),
                multi: true
            },
        ])], decls: 9, vars: 16, consts: function () { let i18n_5; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_7585826646011739428$$FESM2015_FW_FILES_JS_6 = goog.getMsg("Edit");
        i18n_5 = MSG_EXTERNAL_7585826646011739428$$FESM2015_FW_FILES_JS_6;
    }
    else {
        i18n_5 = $localize `:␟28f86ffd419b869711aa13f5e5ff54be6d70731c␟7585826646011739428:Edit`;
    } return [[1, "mb-2"], ["title", i18n_5, "href", "javascript:void(0);", "class", "custom-icon", 3, "click", 4, "ngIf"], ["class", "text-danger custom-icon", "href", "javascript:void(0);", 3, "title", "click", 4, "ngIf"], ["class", "form-control-file input-file", "type", "file", "accept", "image/*", 3, "id", "change", 4, "ngIf"], ["class", "mensaje-cargando", 4, "ngIf"], [1, "pl-1"], ["alt", "", 1, "img-thumbnail", "img-responsive", "image-cover", "p-0", 3, "src"], ["title", i18n_5, "href", "javascript:void(0);", 1, "custom-icon", 3, "click"], ["href", "javascript:void(0);", 1, "text-danger", "custom-icon", 3, "title", "click"], ["type", "file", "accept", "image/*", 1, "form-control-file", "input-file", 3, "id", "change"], ["imageInput", ""], [1, "mensaje-cargando"], [1, "fa", "fa-spinner", "fa-spin"]]; }, template: function ImageFreeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "label");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, ImageFreeComponent_a_3_Template, 2, 2, "a", 1);
        ɵngcc0.ɵɵtemplate(4, ImageFreeComponent_a_4_Template, 2, 3, "a", 2);
        ɵngcc0.ɵɵtemplate(5, ImageFreeComponent_input_5_Template, 2, 1, "input", 3);
        ɵngcc0.ɵɵtemplate(6, ImageFreeComponent_div_6_Template, 3, 1, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelement(8, "img", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.editing && ctx.required ? "required" : "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loading && ctx.editing && (ctx.image == null ? null : ctx.image.name) && ctx.removable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing && ctx.loading);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("border-radius", ctx.borderRadius, "px")("max-width", ctx.maxWidth, "px")("max-height", ctx.maxHeight, "px")("border", ctx.border);
        ɵngcc0.ɵɵproperty("src", ctx.imagePath, ɵngcc0.ɵɵsanitizeUrl);
    } }, directives: [ɵngcc2.NgIf], styles: ["[_nghost-%COMP%]{position:relative}input[_ngcontent-%COMP%]:focus{outline:none}.input-file[_ngcontent-%COMP%]{display:none}.custom-icon[_ngcontent-%COMP%]{margin-left:5px}[_nghost-%COMP%]{display:inline-block}.input-fichero[_ngcontent-%COMP%]{display:none!important;width:0}.nombre-archivo-descargar[_ngcontent-%COMP%]{color:#20a8d8;cursor:pointer;font-weight:400;margin-top:5px}.boton-seleccionar-archivo[_ngcontent-%COMP%]{margin-right:5px}.mensaje-no-hay-fichero[_ngcontent-%COMP%]{margin-top:5px}.mensaje-cargando[_ngcontent-%COMP%]{margin-top:7px;float:left}.vista-imagen[_ngcontent-%COMP%]{width:100%;height:100%}"] });
ImageFreeComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: FilesService },
    { type: NgbModal }
];
ImageFreeComponent.propDecorators = {
    maxWidth: [{ type: Input }],
    maxHeight: [{ type: Input }],
    uniqueIdentifier: [{ type: Input }],
    persistentFileUrl: [{ type: Input }],
    defaultImagePath: [{ type: Input }],
    editing: [{ type: Input }],
    crop: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    shape: [{ type: Input }],
    border: [{ type: Input }],
    loading: [{ type: Input }],
    editIconClass: [{ type: Input }],
    deleteIconClass: [{ type: Input }],
    chargingChange: [{ type: Output }],
    removable: [{ type: Input }],
    textChange: [{ type: Input }],
    textLoading: [{ type: Input }],
    label: [{ type: Input }],
    imageInput: [{ type: ViewChild, args: ['imageInput',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImageFreeComponent, [{
        type: Component,
        args: [{
                selector: 'fw-image-free',
                template: "<div class=\"mb-2\">\r\n    <label [class]=\"editing && required? 'required': ''\">{{label}}</label>\r\n    <a title=\"Edit\" i18n-title href=\"javascript:void(0);\" (click)=\"openInput()\" class=\"custom-icon\" *ngIf=\"editing\">\r\n        <i [class]=\"editIconClass\"></i>\r\n    </a>\r\n\r\n    <a title=\"{{textDelete}}\" *ngIf=\"!loading && editing && image?.name && removable\"\r\n       class=\"text-danger custom-icon\" href=\"javascript:void(0);\" (click)=\"delete()\">\r\n        <i [class]=deleteIconClass></i>\r\n    </a>\r\n\r\n    <input class=\"form-control-file input-file\" #imageInput id=\"imageInput{{uniqueIdentifier}}\" type=\"file\"\r\n           accept=\"image/*\"\r\n           (change)=\"onUpload($event)\" *ngIf=\"editing\">\r\n\r\n    <div *ngIf=\"editing && loading\" class=\"mensaje-cargando\">\r\n        <span class=\"fa fa-spinner fa-spin\"></span> {{textLoading}}</div>\r\n    <div class=\"pl-1\">\r\n        <img [src]=\"imagePath\" class=\"img-thumbnail img-responsive image-cover p-0\"\r\n             [style.borderRadius.px]=\"borderRadius\" alt=\"\"\r\n             [style.max-width.px]=\"maxWidth\" [style.max-height.px]=\"maxHeight\" [style.border]=\"border\">\r\n    </div>\r\n</div>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => ImageFreeComponent),
                        multi: true
                    },
                ],
                styles: [":host{position:relative}input:focus{outline:none}.input-file{display:none}.custom-icon{margin-left:5px}:host{display:inline-block}.input-fichero{display:none!important;width:0}.nombre-archivo-descargar{color:#20a8d8;cursor:pointer;font-weight:400;margin-top:5px}.boton-seleccionar-archivo{margin-right:5px}.mensaje-no-hay-fichero{margin-top:5px}.mensaje-cargando{margin-top:7px;float:left}.vista-imagen{width:100%;height:100%}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: FilesService }, { type: ɵngcc4.NgbModal }]; }, { maxWidth: [{
            type: Input
        }], maxHeight: [{
            type: Input
        }], crop: [{
            type: Input
        }], border: [{
            type: Input
        }], editIconClass: [{
            type: Input
        }], deleteIconClass: [{
            type: Input
        }], chargingChange: [{
            type: Output
        }], removable: [{
            type: Input
        }], textChange: [{
            type: Input
        }], textLoading: [{
            type: Input
        }], label: [{
            type: Input
        }], uniqueIdentifier: [{
            type: Input
        }], editing: [{
            type: Input
        }], loading: [{
            type: Input
        }], persistentFileUrl: [{
            type: Input
        }], defaultImagePath: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], shape: [{
            type: Input
        }], imageInput: [{
            type: ViewChild,
            args: ['imageInput']
        }] }); })();

class VideoComponent {
    constructor(filesService) {
        this.filesService = filesService;
        this.loading = new EventEmitter();
        this.textSelect = this.filesService.config.i18n.fileSelect || 'Select file';
        this.textNoFileSelected = this.filesService.config.i18n.fileNoFileSelected || 'No file selected';
        this.textLoading = this.filesService.config.i18n.fileLoading || 'Loading';
        /* the method set in registerOnChange, it is just
         a placeholder for a method that takes one parameter,
         we use it to emit changes back to the form */
        this.propagateChange = (_) => {
        };
        this.options = { concurrency: 1, maxUploads: 3 };
        this.uniqueIdentifier = 1; // TODO
        this.uploadInput = new EventEmitter();
    }
    ngOnInit() {
        if (this.editing === undefined) {
            this.editing = true;
        }
    }
    abrirInput(element) {
        document.getElementById('inputVideo' + this.uniqueIdentifier).click();
        element.currentTarget.blur();
    }
    getRutaVideo(video) {
        if (video && video.id) {
            // The id is sent to facilitate the caching
            return this.persistentFileUrl + '?id=' + this.video.id;
        }
        else {
            // TODO La ruta por defecto debería ser configruable a nivel de módulo en vez de estar aquí hardcodeada
            return this.defaultVideoPath || this.filesService.getUrlImageDefault();
        }
    }
    getVideoPoster() {
        return this.filesService.getUrlVideoPosterDefault();
    }
    delete() {
        this.video = null;
        this.propagateChange(this.video);
        this.videoPath = this.getRutaVideo(this.video);
    }
    onUploadOutput(output) {
        if (output.type === 'allAddedToQueue') { // when all files added in queue TODO La url debería configurarse a nivel de módulo
            const event = this.filesService.createUploadInput();
            this.uploadInput.emit(event);
        }
        else if (output.type === 'addedToQueue') {
            this.generateThumb(output.file.nativeFile);
        }
        else if (output.type === 'start') {
            this.loadingVideo = true;
        }
        else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
            this.loadingVideo = output.file.progress.status === 1;
        }
        else if (output.type === 'done') {
            this.video = this.filesService.createFichero(output);
            this.loadingVideo = false;
            this.propagateChange(this.video);
        }
        this.loading.emit(this.loadingVideo);
    }
    generateThumb(file) {
        if (file != null) {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            const fileReader$ = fromEvent(fileReader, 'load').subscribe(result => {
                this.videoPath = fileReader.result;
            });
        }
    }
    /* registers 'fn' that will be fired when changes are made. This is how we emit the changes back to the form */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched(fn) {
    }
    setDisabledState(isDisabled) {
    }
    writeValue(obj) {
        this.video = obj;
        this.videoPath = this.getRutaVideo(this.video);
    }
}
VideoComponent.ɵfac = function VideoComponent_Factory(t) { return new (t || VideoComponent)(ɵngcc0.ɵɵdirectiveInject(FilesService)); };
VideoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VideoComponent, selectors: [["fw-video"]], inputs: { editing: "editing", persistentFileUrl: "persistentFileUrl", defaultVideoPath: "defaultVideoPath" }, outputs: { loading: "loading" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => VideoComponent),
                multi: true
            },
        ])], decls: 5, vars: 3, consts: [["class", "img-thumbnail vista-imagen mb-1", 3, "src", 4, "ngIf"], ["preload", "none", "controls", "true", "class", "vista-video", "playsinline", "", 3, "src", 4, "ngIf"], [4, "ngIf"], [1, "img-thumbnail", "vista-imagen", "mb-1", 3, "src"], ["preload", "none", "controls", "true", "playsinline", "", 1, "vista-video", 3, "src"], ["type", "button", 1, "btn", "btn-default", "pull-left", "boton-seleccionar-archivo", 3, "click"], ["type", "file", "ngFileSelect", "", "accept", "video/*", 1, "input-fichero", 3, "id", "options", "uploadInput", "uploadOutput"], ["class", "pull-left", 4, "ngIf"], ["class", "pull-left mensaje-cargando", 4, "ngIf"], [1, "pull-left"], ["class", "pull-left", "style", "margin-top:5px;", 4, "ngIf"], ["class", "mensaje-no-hay-fichero pull-left", 4, "ngIf"], ["class", "fa fa-times pull-left icono-eliminar", 3, "click", 4, "ngIf"], [1, "pull-left", 2, "margin-top", "5px"], [1, "mensaje-no-hay-fichero", "pull-left"], [1, "fa", "fa-times", "pull-left", "icono-eliminar", 3, "click"], [1, "pull-left", "mensaje-cargando"], [1, "fa", "fa-spinner", "fa-spin"]], template: function VideoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵtemplate(2, VideoComponent_img_2_Template, 1, 1, "img", 0);
        ɵngcc0.ɵɵtemplate(3, VideoComponent_video_3_Template, 1, 1, "video", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, VideoComponent_div_4_Template, 7, 6, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.video == null ? null : ctx.video.name));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.video == null ? null : ctx.video.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.NgFileSelectDirective], styles: ["[_nghost-%COMP%]{display:flex}.input-fichero[_ngcontent-%COMP%]{display:none!important;width:0}.nombre-archivo-descargar[_ngcontent-%COMP%]{color:#20a8d8;cursor:pointer;font-weight:400;margin-top:5px}.boton-seleccionar-archivo[_ngcontent-%COMP%]{margin-right:5px}.icono-eliminar[_ngcontent-%COMP%]{margin-top:8px;font-size:16px;margin-left:5px;color:#8b0000;cursor:pointer}.mensaje-no-hay-fichero[_ngcontent-%COMP%]{margin-top:5px}.mensaje-cargando[_ngcontent-%COMP%]{margin-top:7px}.vista-imagen[_ngcontent-%COMP%], .vista-video[_ngcontent-%COMP%]{width:100%}"] });
VideoComponent.ctorParameters = () => [
    { type: FilesService }
];
VideoComponent.propDecorators = {
    persistentFileUrl: [{ type: Input }],
    loading: [{ type: Output }],
    defaultVideoPath: [{ type: Input }],
    editing: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VideoComponent, [{
        type: Component,
        args: [{
                selector: 'fw-video',
                template: "<div>\r\n    <div>\r\n        <img [src]=\"getVideoPoster()\" *ngIf=\"!video?.name\" class=\"img-thumbnail vista-imagen mb-1\">\r\n        <video [src]=\"videoPath\" *ngIf=\"video?.name\" preload=\"none\" controls=\"true\" class=\"vista-video\"\r\n               playsinline></video>\r\n    </div>\r\n\r\n    <div *ngIf=\"editing\">\r\n\r\n        <button type=\"button\" class=\"btn btn-default pull-left boton-seleccionar-archivo\"\r\n                (click)=\"abrirInput($event)\">\r\n            <span> {{textSelect}}</span>\r\n        </button>\r\n\r\n        <input id=\"inputVideo{{uniqueIdentifier}}\" type=\"file\" ngFileSelect [options]=\"options\"\r\n               class=\"input-fichero\" (uploadOutput)=\"onUploadOutput($event)\" [uploadInput]=\"uploadInput\"\r\n               accept=\"video/*\">\r\n\r\n        <div *ngIf=\"!loadingVideo\" class=\"pull-left\">\r\n            <div *ngIf=\"video?.name\" class=\"pull-left\" style=\"margin-top:5px;\">\r\n                {{video.name}}\r\n            </div>\r\n\r\n            <div *ngIf=\"!video || !video.name\" class=\"mensaje-no-hay-fichero pull-left\">{{textNoFileSelected}}</div>\r\n\r\n            <div *ngIf=\"video?.name\" class=\"fa fa-times pull-left icono-eliminar\" (click)=\"delete()\"></div>\r\n        </div>\r\n        <div *ngIf=\"loadingVideo\" class=\"pull-left mensaje-cargando\">\r\n            <span class=\"fa fa-spinner fa-spin\"></span> <span>{{textLoading}}</span></div>\r\n    </div>\r\n\r\n</div>\r\n\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => VideoComponent),
                        multi: true
                    },
                ],
                styles: [":host{display:flex}.input-fichero{display:none!important;width:0}.nombre-archivo-descargar{color:#20a8d8;cursor:pointer;font-weight:400;margin-top:5px}.boton-seleccionar-archivo{margin-right:5px}.icono-eliminar{margin-top:8px;font-size:16px;margin-left:5px;color:#8b0000;cursor:pointer}.mensaje-no-hay-fichero{margin-top:5px}.mensaje-cargando{margin-top:7px}.vista-imagen,.vista-video{width:100%}"]
            }]
    }], function () { return [{ type: FilesService }]; }, { loading: [{
            type: Output
        }], editing: [{
            type: Input
        }], persistentFileUrl: [{
            type: Input
        }], defaultVideoPath: [{
            type: Input
        }] }); })();

class RichEditorImagesComponent extends RichEditorComponent {
    constructor(required, injector, validators, asyncValidators, contextFormService, inputService, sanitizer, filesService) {
        super(required, injector, validators, asyncValidators, contextFormService, inputService, sanitizer);
        this.contextFormService = contextFormService;
        this.sanitizer = sanitizer;
        this.filesService = filesService;
        this.allowImageUpload = true;
    }
    ngAfterContentInit() {
        this.initFilePicker();
    }
    initFilePicker() {
        const vm = this;
        if (this.allowImageUpload) {
            this.filePickerCallback = function (callback, value, meta) {
                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                if (meta.filetype === 'image') {
                    input.setAttribute('accept', 'image/*');
                }
                input.onchange = function () {
                    const file = input.files[0];
                    vm.filesService.uploadFile(file).subscribe(ev => {
                        if (ev.type === 4) {
                            const reader = new FileReader();
                            const fichero = new FwFileDTO();
                            fichero.temporalFileName = ev.body;
                            fichero.name = file.name;
                            callback(vm.getUrlTemporalFile(fichero), {
                                text: file.name,
                                alt: file.name,
                                title: file.name
                            });
                            reader.readAsDataURL(file);
                        }
                    }, err => {
                        console.log(err);
                    });
                };
                input.click();
            };
        }
        else {
            this.filePickerCallback = false;
        }
    }
    getUrlTemporalFile(file) {
        return file ? location.origin + '/' + this.filesService.getTemporalFileName() + '/' + file.temporalFileName + '?fileName=' + file.name
            : 'content/img/default.jpg';
    }
}
RichEditorImagesComponent.ɵfac = function RichEditorImagesComponent_Factory(t) { return new (t || RichEditorImagesComponent)(ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(NG_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(NG_ASYNC_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.InputService), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(FilesService)); };
RichEditorImagesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RichEditorImagesComponent, selectors: [["fw-rich-editor-images"]], inputs: { allowImageUpload: "allowImageUpload" }, features: [ɵngcc0.ɵɵProvidersFeature([
            provideValueAccessor(RichEditorImagesComponent),
            InputService
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 9, consts: [[3, "label", "placeholder", "ngModel", "maxLength", "height", "presetToolbar", "customToolbarConstant", "showInlineStyles", "filePickerCallback", "ngModelChange"]], template: function RichEditorImagesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "fw-rich-editor", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function RichEditorImagesComponent_Template_fw_rich_editor_ngModelChange_0_listener($event) { return ctx.value = $event; });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("label", ctx.label)("placeholder", ctx.placeholder)("ngModel", ctx.value)("maxLength", ctx.maxLength)("height", ctx.height)("presetToolbar", ctx.presetToolbar)("customToolbarConstant", ctx.customToolbarConstant)("showInlineStyles", ctx.showInlineStyles)("filePickerCallback", ctx.filePickerCallback);
    } }, directives: [ɵngcc7.RichEditorComponent, ɵngcc9.NgControlStatus, ɵngcc9.NgModel], encapsulation: 2 });
RichEditorImagesComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: Injector },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] }] },
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: InputService },
    { type: DomSanitizer },
    { type: FilesService }
];
RichEditorImagesComponent.propDecorators = {
    allowImageUpload: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RichEditorImagesComponent, [{
        type: Component,
        args: [{
                selector: 'fw-rich-editor-images',
                template: `
        <fw-rich-editor [label]="label"
                        [placeholder]="placeholder"
                        [(ngModel)]="value"
                        [maxLength]="maxLength"
                        [height]="height"
                        [presetToolbar]="presetToolbar"
                        [customToolbarConstant]="customToolbarConstant"
                        [showInlineStyles]="showInlineStyles"
                        [filePickerCallback]="filePickerCallback">
        </fw-rich-editor>`,
                providers: [
                    provideValueAccessor(RichEditorImagesComponent),
                    InputService
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_VALIDATORS]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_ASYNC_VALIDATORS]
            }] }, { type: ɵngcc7.ContextFormService, decorators: [{
                type: Optional
            }] }, { type: ɵngcc7.InputService }, { type: ɵngcc8.DomSanitizer }, { type: FilesService }]; }, { allowImageUpload: [{
            type: Input
        }] }); })();

class FwFilesModule {
}
FwFilesModule.ɵfac = function FwFilesModule_Factory(t) { return new (t || FwFilesModule)(); };
FwFilesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FwFilesModule });
FwFilesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[NgxUploaderModule, CommonModule, AngularCropperjsModule, NgbModalModule, NgxSpinnerModule, FwFormsModule, FormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FwFilesModule, { declarations: function () { return [FileComponent, ImageComponent, VideoComponent, ImageCropperComponent, ImageFreeComponent, RichEditorImagesComponent]; }, imports: function () { return [NgxUploaderModule, CommonModule, AngularCropperjsModule, NgbModalModule, NgxSpinnerModule, FwFormsModule, FormsModule]; }, exports: function () { return [FileComponent, ImageComponent, VideoComponent, ImageCropperComponent, ImageFreeComponent, RichEditorImagesComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwFilesModule, [{
        type: NgModule,
        args: [{
                imports: [NgxUploaderModule, CommonModule, AngularCropperjsModule, NgbModalModule, NgxSpinnerModule, FwFormsModule, FormsModule],
                exports: [FileComponent, ImageComponent, VideoComponent, ImageCropperComponent, ImageFreeComponent, RichEditorImagesComponent],
                declarations: [FileComponent, ImageComponent, VideoComponent, ImageCropperComponent, ImageFreeComponent, RichEditorImagesComponent],
                entryComponents: [ImageCropperComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of ficheros
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FileComponent, FilesService, FwFileDTO, FwFilesConfig, FwFilesModule, ImageComponent, ImageCropperComponent, ImageFreeComponent, RichEditorImagesComponent, VideoComponent };

//# sourceMappingURL=fw-files.js.map